import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/GeoTrackingApi/" );

/* eslint-disable arrow-body-style */

/**
 * Gets the current user's location
 * @returns {string} The user's country code
 */
export const getUserLocation = () => {
  return instance.get( "GetUserLocation" );
};
